const security = {
  roles: {
    admin: 'admin',
    userManager: 'user_manager',
    screenManager: 'screen_manager',
    siteManager: 'site_manager',
    orgManager: 'org_manager',
    activityLogManager:'activity_manager',
    fileManager: 'file_manager',
    playlistManager: 'playlist_manager',
    scheduleManager: 'schedule_manager',
    basicUser: 'basic_user',
  },
}

const constants = {
  app: {
    meta: {
      name: 'Screen Flow',
      subName: 'Manager',
      copyright: `Copyright \u00A9 2024 by Screen Flow`,
    },
    loadingTime: 3000,
    logo: {
      light: 'https://static.screenflow.co.uk/images/logo/logo-dark-text.png',
      dark: 'https://static.screenflow.co.uk/images/logo/logo-light-text.png',
    },
  },
  auth: {
    namespaces: {
      root: 'https://screenflow.co.uk',
      roles: `https://screenflow.co.uk/roles`,
      uid: `https://screenflow.co.uk/uid`,
    },
  },
  api: {
    baseUrl: `${process.env.VUE_APP_API_BASE_URL}`,
  },
  websockets: {
    baseUrl: `${process.env.VUE_APP_WS_BASE_URL}`,
    namespaces: {
      root: '/ws',
      controller: `manager/controller`,
      fileManager: `manager/file-manager`,
    },
  },
  nav: {
    dashboard: {
      name: 'dashboard',
      showInNav: true,
      elemId:'sf-DashboardNav',
      meta: {
        title: 'Dashboard',
        subtitle: '',
        icon: 'mdi-gauge',
        breadcrumbs: ['Dashboard'],
        rbac: [security.roles.basicUser],
      },
    },
    controller: {
      name: 'controller',
      showInNav: true,
      elemId: 'sf-ControllerNav',
      meta: {
        title: 'Controller',
        subtitle: '',
        icon: 'mdi-television',
        breadcrumbs: ['Controller'],
        rbac: [security.roles.basicUser],
      },
      children: {
        controllerSiteUid: {
          name: 'controller-siteuid',
          showInNav: false,
          meta: {
            title: 'Controller',
            subtitle: '',
            icon: 'mdi-television',
            breadcrumbs: ['Controller'],
            rbac: [security.roles.basicUser],
          },
        }
      },
    },
    media: {
      showInNav: true,
      meta: {
        title: 'Media',
        subtitle: '',
        icon: 'mdi-multimedia',
        breadcrumbs: ['Media'],
        rbac: [security.roles.admin, security.roles.fileManager, security.roles.playlistManager, security.roles.scheduleManager],
      },
      children: {
        fileManager: {
          name: 'media-file-manager',
          showInNav: true,
          elemId: 'sf-MediaFileManagerNav',
          meta: {
            title: 'File Manager',
            subtitle: '',
            icon: 'mdi-folder-multiple-image',
            breadcrumbs: ['Media', 'File Manager'],
            rbac: [security.roles.admin, security.roles.fileManager],
          },
          children: {
            site: {
              name: 'media-file-manager-site',
              showInNav: false,
              meta: {
                title: 'File Manager',
                subtitle: '',
                icon: 'mdi-folder-multiple-image',
                breadcrumbs: ['Media', 'File Manager'],
                rbac: [security.roles.admin, security.roles.fileManager],
              },
            }
          },
        },
        playlists: {
          name: 'media-playlists',
          showInNav: true,
          elemId: 'sf-MediaPlaylistsNav',
          meta: {
            title: 'Playlists',
            subtitle: '',
            icon: 'mdi-playlist-play',
            breadcrumbs: ['Media', 'Playlists'],
            rbac: [security.roles.admin, security.roles.playlistManager],
          },
          children: {
            site: {
              name: 'media-playlists-site',
              showInNav: false,
              meta: {
                title: 'Playlists',
                subtitle: '',
                icon: 'mdi-playlist-play',
                breadcrumbs: ['Media', 'Playlists'],
                rbac: [security.roles.admin, security.roles.playlistManager],
              },
            }
          },
        },
        schedules: {
          name: 'media-schedules',
          showInNav: true,
          elemId: 'sf-SchedulesNav',
          meta: {
            title: 'Schedules',
            subtitle: '',
            icon: 'mdi-file-clock-outline',
            breadcrumbs: ['Media', 'Schedules'],
            rbac: [security.roles.admin, security.roles.scheduleManager],
          },
          children: {
            site: {
              name: 'media-schedules-site',
              showInNav: false,
              meta: {
                title: 'Schedules',
                subtitle: '',
                icon: 'mdi-file-clock-outline',
                breadcrumbs: ['Media', 'Schedules'],
                rbac: [security.roles.admin, security.roles.scheduleManager],
              },
            }
          },
        },
      },
    },
    settings: {
      showInNav: true,
      meta: {
        title: 'Settings',
        subtitle: '',
        icon: 'mdi-cog',
        breadcrumbs: ['Settings'],
        rbac: [security.roles.admin, security.roles.userManager, security.roles.screenManager, security.roles.siteManager, security.roles.orgManager],
      },
      children: {
        screens: {
          name: 'settings-screens',
          showInNav: true,
          meta: {
            title: 'Screens',
            subtitle: '',
            icon: 'mdi-television',
            breadcrumbs: ['Settings', 'Screens'],
            rbac: [security.roles.admin, security.roles.screenManager],
          },
          children: {
            edit: {
              name: 'settings-screen-edit',
              showInNav: false,
              meta: {
                title: 'Edit Screen',
                subtitle: '',
                icon: 'mdi-pencil',
                breadcrumbs: ['Settings', 'Screens', 'Edit'],
                rbac: [security.roles.admin, security.roles.screenManager],
              },
            },
          },
        },
        org: {
          name: 'settings-org',
          showInNav: true,
          meta: {
            title: 'Org',
            subtitle: '',
            icon: 'mdi-office-building',
            breadcrumbs: ['Settings', 'Org'],
            rbac: [security.roles.admin, security.roles.orgManager],
          },
        },
        sites: {
          name: 'settings-sites',
          showInNav: true,
          meta: {
            title: 'Sites',
            subtitle: '',
            icon: 'mdi-sitemap-outline',
            breadcrumbs: ['Settings', 'Sites'],
            rbac: [security.roles.admin, security.roles.siteManager],
          },
          children: {
            edit: {
              name: 'settings-site-edit',
              showInNav: false,
              meta: {
                title: 'Edit Site',
                subtitle: '',
                icon: 'mdi-pencil',
                breadcrumbs: ['Settings', 'Sites', 'Edit'],
                rbac: [security.roles.admin, security.roles.siteManager],
              },
            },
          },
        },
        users: {
          name: 'settings-users',
          showInNav: true,
          meta: {
            title: 'Users',
            subtitle: '',
            icon: 'mdi-account-multiple',
            breadcrumbs: ['Settings', 'Users'],
            rbac: [security.roles.admin, security.roles.userManager],
          },
          children: {
            edit: {
              name: 'settings-user-edit',
              showInNav: false,
              meta: {
                title: 'Edit User',
                subtitle: '',
                icon: 'mdi-pencil',
                breadcrumbs: ['Settings', 'Users', 'Edit'],
                rbac: [security.roles.admin, security.roles.userManager],
              },
            },
          },
        },
        activity: {
          name: 'settings-activity',
          showInNav: true,
          meta: {
            title: 'Activity Log',
            subtitle: '',
            icon: 'mdi-notebook-outline',
            breadcrumbs: ['Settings', 'Activity Log'],
            rbac: [security.roles.admin, security.roles.activityLogManager],
          },
        },
        billing: {
          name: 'settings-billing',
          showInNav: true,
          meta: {
            title: 'Billing',
            subtitle: '',
            icon: 'mdi-credit-card-outline',
            breadcrumbs: ['Settings', 'Billing'],
            rbac: [security.roles.admin],
          },
          children: {
            manage: {
              name: 'settings-billing-manage',
              showInNav: false,
              meta: {
                title: 'Manage Billing',
                subtitle: '',
                icon: 'mdi-credit-card-edit-outline',
                breadcrumbs: ['Settings', 'Billing', 'Manage'],
                rbac: [security.roles.admin],
              },
            },
          },
        },
      },
    },
  },
  tutorial: [
    {
      step: 1,
      targetElem: '#sf-DashboardNav',
      title: 'Dashboard',
      text: 'The Dashboard gives you an overview of your screens, media, and users',
      icon: 'mdi-gauge',
    },
    {
      step: 2,
      targetElem: '#sf-ControllerNav',
      title: 'Controller',
      text: 'You can control content on your screens as well as change basic settings like transition, duration, and announcements',
      icon: 'mdi-television',
    },
    {
      step: 3,
      targetElem: '#sf-ProfileMenuButton',
      title: 'Account',
      text: 'Use the Account menu to change your password, switch themes, or logout',
      icon: 'mdi-account',
    },

  ],
  screen: {
    status: {
      online: {
        title: 'Online',
        icon: 'mdi-lightning-bolt',
        color: 'success',
        id: 'online',
      },
      updating: {
        title: 'Updating',
        icon: 'mdi-cloud-download',
        color: 'info',
        id: 'updating',
      },
      casting: {
        title: 'Casting',
        icon: 'mdi-cast-connected',
        color: 'info',
        id: 'casting',
      },
      blanked: {
        title: 'Blanked',
        icon: 'mdi-eye-off',
        color: 'grey-darken-3',
        id: 'blanked',
      },
      offline: {
        title: 'Offline',
        icon: 'mdi-cloud-off-outline',
        color: 'error',
        id: 'offline',
      },
      unknown: {
        title: 'Unknown',
        icon: 'mdi-help-circle',
        color: 'grey-darken-2',
        id: 'unknown',
      },
    },
    transition: {
      effects: [
        {
          name: 'Instant',
          value: 'instant',
        },
        {
          name: 'Slide left',
          value: 'slideleft',
        },
        {
          name: 'Slide up',
          value: 'slideup',
        },
        {
          name: 'Fade',
          value: 'fade',
        },
        {
          name: 'Cube',
          value: 'cube',
        },
        {
          name: 'Cards',
          value: 'cards',
        },
        {
          name: 'Flip',
          value: 'flip',
        },
      ]
    },
    actions: {
      manageContent: {
        title: 'Manage Content',
        icon: 'mdi-file-cog',
      },
    },
  },
  media: {
    fileManager: {
      maxThumbnailsPerPage: 10,
      actions: {
        manageContent: {
          title: 'Manage Content',
          icon: 'mdi-file-cog',
        },
      },
    },
  },
};

export default constants;